import React from "react";
import IconPreview from "../BuilderComponents/Preview/IconPreview";
import { RVCatalogPreview } from "./RVTablePreview";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import MapPin from "../../images/mapPin.png";
import FullMapWithSinglePin from "../../images/fullMapWithSinglePin.png";
const FieldPreview = ({ config, classes, onClickElement, node }) => {
  const prefix = config?.prefix_data || "";
  const placeholder = config?.placeholder || config?.name || config?.display || config?.type || "----";
  const postfix = config?.postfix_data || "";
  const title =
    config?.type === "field" ? config.prefix + "." + config.display : config?.display || config?.type || config?.name;
  switch (config.field_type) {
    case "recordset-list":
    case "grid":
    case "rich-grid":
      return <PreviewArrayField onClickElement={onClickElement} node={node} config={config} classes={classes} />;
    case "geolocation":
      return <GeolocationPreview config={config} title={title} />;
    default:
      return (
        <div
          className={`d_flex align_center z-text-default ${classes} ${config.show_chips ? "chip-format" : ""}`}
          style={{ height: "100%", wordBreak: "break-word" }}
          title={title}
        >
          {prefix}
          <div className="d_flex align_center gap_2">
            {config.icon && <IconPreview icon={config.icon || ""} />}
            {config.show_avatar ? (
              <div className="avatar-format">
                <span className="avatar-circle">{placeholder.charAt(0).toUpperCase()}</span>
                <span className="full-field-name">{placeholder}</span>
              </div>
            ) : (
              placeholder
            )}
          </div>
          {postfix}
        </div>
      );
  }
};

const PreviewArrayField = ({ config, node, onClickElement, classes }) => {
  const openListCreation = (e) => {
    e.stopPropagation();
    onClickElement({ type: "catalog_edit", field_id: config.id, field_type: config.field_type });
  };
  return (
    <>
      {config?.table_format ? (
        <TableFormatForFields
          fields={config?.table_fields || []}
          classes={classes}
          table_type={config?.table_view ? config?.table_view?.table_type : "default"}
          showSerialNumber={config?.table_view ? config?.table_view?.show_serial_number : false}
        />
      ) : (
        <div className={`h_100 table-container ${classes}`}>
          <ButtonActionIcon type={"assistant_direction"} className="settings-btn" onClick={openListCreation} />
          <RVCatalogPreview catalog={config.catalog || {}} width={parseInt(node.style.width)} id={node.id} />
        </div>
      )}
    </>
  );
};

const TableFormatForFields = ({ fields, classes, table_type = "default", showSerialNumber }) => {
  let rows = 5;
  const emptyRows = Array(rows).fill(null);

  const tableStyles = {
    default: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff"
    },
    alt_row: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff"
    },
    alt_col: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff"
    }
  };

  const getRowStyle = (index) => {
    if (table_type === "alt_row") {
      return { backgroundColor: index % 2 === 0 ? "#f2f2f2" : "#ffffff" };
    }
    return {};
  };

  const getCellStyle = (colIndex) => {
    if (table_type === "alt_col") {
      return { backgroundColor: colIndex % 2 === 0 ? "#f2f2f2" : "#ffffff" };
    }
    return {};
  };

  return (
    <div className={`h_100 table-container ${classes} w_100 overflow_scroll`}>
      <table className="w_100 h_100" style={tableStyles[table_type] || tableStyles.default}>
        <thead>
          <tr>
            {showSerialNumber && (
              <th className="overflow_hidden text_overflow p-2" style={getCellStyle(0)}>
                S.No
              </th>
            )}
            {fields?.map((field, colIndex) => (
              <th
                key={`${field.key}-${colIndex}`}
                className="overflow_hidden text_overflow p-2"
                style={getCellStyle(colIndex)}
              >
                {field.field_custom_label || field.display}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {emptyRows.map((_, rowIndex) => (
            <tr key={rowIndex} style={getRowStyle(rowIndex)}>
              {showSerialNumber && (
                <td
                  className="p-2 overflow_hidden text_overflow"
                  style={table_type === "alt_row" ? {} : getCellStyle(0)}
                >
                  {rowIndex + 1}
                </td>
              )}
              {fields.map((field, colIndex) => (
                <td
                  key={`${field.key}-${rowIndex}-${colIndex}`}
                  className="p-2 overflow_hidden text_overflow"
                  style={table_type === "alt_row" ? {} : getCellStyle(colIndex)}
                >
                  -
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const GeolocationPreview = ({ config, title = "" }) => {
  if (config.show_full_map) {
    return (
      <div className="h_100">
        <img className="w_100 h_100" style={{ objectFit: "cover" }} src={FullMapWithSinglePin} alt="FullMap" />
      </div>
    );
  } else {
    return (
      <div className="d_flex justify_center align_center h_100" title={title}>
        <img src={MapPin} style={{ width: "18px" }} alt="MapPin" />
      </div>
    );
  }
};

export default FieldPreview;
